// Reports Configuration
// Define your Superset dashboard configurations here

export interface ReportConfig {
  id: string;
  name: string;
  description?: string;
  icon: string;
  // Superset configuration
  supersetDashboardId: string;      // The dashboard ID in Superset
  supersetEmbeddedUuid: string;     // The embedded UUID from Superset
  // Optional filters
  defaultFilters?: { [key: string]: any };
}

export interface ReportCategory {
  id: string;
  name: string;
  icon: string;
  expanded: boolean;
  reports: ReportConfig[];
}

// Superset connection settings
export const SUPERSET_CONFIG = {
  domain: 'http://localhost:8088',
  username: 'admin',
  password: 'admin',
  provider: 'db'
};

// Report categories and their reports
export const REPORT_CATEGORIES: ReportCategory[] = [
  {
    id: 'document-reports',
    name: 'Document Reports',
    icon: 'description',
    expanded: true,
    reports: [
      {
        id: 'overall-summary',
        name: 'Overall Summary Report',
        description: 'Overview of all documents in the system',
        icon: 'dashboard',
        supersetDashboardId: '11',
        supersetEmbeddedUuid: 'f1575b31-98f4-4083-ac6a-b6dd34c8675b'
      },
      {
        id: 'claims-report',
        name: 'Claims Reports',
        description: 'Claims document statistics and trends',
        icon: 'receipt_long',
        supersetDashboardId: '12',
        supersetEmbeddedUuid: '236202c2-9e01-42b2-96e7-251549fe12a5' // Add your embedded UUID
      },
      {
        id: 'quotation-report',
        name: 'Quotation Reports',
        description: 'Quotation documents analysis',
        icon: 'request_quote',
        supersetDashboardId: '13',
        supersetEmbeddedUuid: '' // Add your embedded UUID
      },
      {
        id: 'policy-report',
        name: 'Policy Reports',
        description: 'Policy documents overview',
        icon: 'policy',
        supersetDashboardId: '14',
        supersetEmbeddedUuid: '' // Add your embedded UUID
      }
    ]
  },
  {
    id: 'workflow-reports',
    name: 'Workflow Reports',
    icon: 'account_tree',
    expanded: false,
    reports: [
      {
        id: 'workflow-instances',
        name: 'Workflow Instances Report',
        description: 'Active and completed workflow instances',
        icon: 'play_circle',
        supersetDashboardId: '15',
        supersetEmbeddedUuid: '' // Add your embedded UUID
      },
      {
        id: 'workflow-performance',
        name: 'Workflow Performance Report',
        description: 'Workflow efficiency and timing analysis',
        icon: 'speed',
        supersetDashboardId: '16',
        supersetEmbeddedUuid: '' // Add your embedded UUID
      },
      {
        id: 'user-task-report',
        name: 'User Task Report',
        description: 'Tasks assigned to users',
        icon: 'assignment_ind',
        supersetDashboardId: '17',
        supersetEmbeddedUuid: '' // Add your embedded UUID
      }
    ]
  },
  {
    id: 'finance-reports',
    name: 'Finance Reports',
    icon: 'payments',
    expanded: false,
    reports: [
      {
        id: 'invoice-report',
        name: 'Invoice Reports',
        description: 'Invoice processing and payment status',
        icon: 'receipt',
        supersetDashboardId: '18',
        supersetEmbeddedUuid: '' // Add your embedded UUID
      },
      {
        id: 'transport-report',
        name: 'Transport Reports',
        description: 'Transport and logistics documents',
        icon: 'local_shipping',
        supersetDashboardId: '19',
        supersetEmbeddedUuid: '' // Add your embedded UUID
      }
    ]
  }
];

// Helper function to get all reports flat
export function getAllReports(): ReportConfig[] {
  return REPORT_CATEGORIES.flatMap(cat => cat.reports);
}

// Helper function to find a report by ID
export function getReportById(reportId: string): ReportConfig | undefined {
  return getAllReports().find(r => r.id === reportId);
}

// Helper function to find category by report ID
export function getCategoryByReportId(reportId: string): ReportCategory | undefined {
  return REPORT_CATEGORIES.find(cat => cat.reports.some(r => r.id === reportId));
}
